// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCTMObS5tMOoCv2f-0rbM57gkJE92Wq5eM",
    authDomain: "computer-services-a2c45.firebaseapp.com",
    projectId: "computer-services-a2c45",
    storageBucket: "computer-services-a2c45.appspot.com",
    messagingSenderId: "176705825605",
    appId: "1:176705825605:web:08937c45f062db8a162c2c",
    measurementId: "G-FX4XH8PJVG"
  };

  export default firebaseConfig;